import { Flex, Link, Text } from '@opendoor/bricks/core';

const Copyright: React.FC = () => (
  <span>&copy; {new Date().getFullYear()} Opendoor | Equal Housing Opportunity | </span>
);

const Footer = () => {
  const analyticsName = 'reception';
  return (
    <Flex as="footer" alignItems="center" justifyContent={'center'} marginX="20px">
      <Text size="90" color="warmgrey900">
        <Copyright />
        <Link
          href="https://opendoor.com/terms"
          analyticsName={`${analyticsName}-terms-of-service`}
          aria-label="Go to Opendoor terms of service page."
        >
          Terms of Service
        </Link>
        {' · '}
        <Link
          href="https://opendoor.com/privacy"
          analyticsName={`${analyticsName}-privacy-policy`}
          aria-label="Go to Opendoor privacy policy page."
        >
          Privacy Policy
        </Link>
        {' · '}
        <Link
          href="https://opendoor.com/privacyrequest"
          analyticsName={`${analyticsName}-do-not-sell-my-info`}
          aria-label="Go to Opendoor privacy request page."
        >
          Do Not Sell My Info
        </Link>
      </Text>
    </Flex>
  );
};

export default Footer;
